// extracted by mini-css-extract-plugin
module.exports = {"arrowContainer":"styles-module--arrowContainer--33oI0","up":"styles-module--up--3hAT6","right":"styles-module--right--j1Mf1","left":"styles-module--left--2ooJG"};